<app-base-page pageTitle="Session Events"
	[pageContext]="pageContext"
	utilityMenuOperationGroupName="">
	<div class="ui-g-12">
	</div>
</app-base-page>